import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import Loader from "./../../../shared/loader";
import Onboarding from '../../../shared/onboarding/onboarding';
import {
  fetchAnimal,
  assignScenesToAnimal,
  clearRedirect,
  fetchAllScenes,
  fetchAllSceneSettings,
  fetchScenesAssignedToAnimal,
  findInScript,
  clearSceneSearchResults,
  setSceneAssignedToAnimal
} from "./ducks/actions";
import Form from "./scenes-form";
import {
  searchScenes,
  SEARCH_SCENES_FOR_SET_DRESSING
} from "../../scenes/search/ducks/actions";
import SearchScenesForm from "../../scenes/search/search-scenes-form";
import ScriptSearch from "../../script/search/script-search";
import { OnboardingStep1ClassName, OnboardingStep2ClassName } from './ducks/reducer';

function AnimalScenes(props) {
  const animalId = props.animalId || props.match.params.animalId;
  const filmId = props.filmId || props.match.params.filmId;
  const {
    fetchAllScenes,
    animal,
    fetchAnimal,
    fetchScenesAssignedToAnimal,
    assignScenesToAnimal,
    setSceneAssignedToAnimal,
    loadingAnimal,
    loadingScenes,
    allScenes,
    searchScenes,
    findInScript,
    clearSceneSearchResults,
    errors,
    readOnly,
    sceneId,
    embedded,
    onboardingSteps,
    loadingSceneSettings,
    findingInScript,
    searchingScenes
  } = props;

  const invalidIds = ["add", "scenes"];

  // const allSelectedScenes = (props.selectedSceneIds || []).concat(
  //   props.searchedScenes?.map((s) => s.id)
  // );

  useEffect(() => {
    fetchAnimal(filmId, animalId);
    if (!sceneId) {
      fetchScenesAssignedToAnimal(filmId, animalId);
    }
  }, [filmId, animalId]);

  useEffect(() => {
    if (animal?.sceneSettingId) {
      fetchAllScenes(filmId, animal.sceneSettingId);
    }
  }, [filmId, animalId, animal]);

  useEffect(() => {
    if (sceneId) {
      setSceneAssignedToAnimal(sceneId);
    }
  }, [sceneId]);

  if (!embedded && props.redirect) {
    if (props.redirect.to === "list") {
      props.clearRedirect();
      const url = `/films/${filmId}/set-dressings/`;
      return <Redirect to={url} />;
    } else {
      props.clearRedirect();
      return <Redirect to={props.redirect.to} />;
    }
  }

  if (invalidIds.indexOf(animalId) > -1) {
    return null;
  }

  const onFindInScript = (e) => {
    e.preventDefault();
    findInScript(filmId, animal.name);
  };

  function renderLoading() {
    return <Loader />;
  }

  function renderForm() {
    return (
      <div className="blade-content">
        <h2 className="menu-label">Set Dressing Scenes</h2>
        {!readOnly && <div className={`box mt-1 ${OnboardingStep1ClassName}`}>
          <SearchScenesForm
            errors={errors}
            mode="edit"
            filmId={filmId}
            animalId={animalId}
            loading={loadingAnimal}
            onSubmit={onSearchScenes}
            findInScript={onFindInScript}
            allCharacters={props.allCharacters}
            allSceneSettings={props.allSceneSettings}
            animalName={animal?.name}
            searchingScenes={searchingScenes}
            scenes={allScenes}
            showCharacters={false}
            showScriptDays={false}
            showSceneSettings={false}
          />
        </div>}
        {!readOnly && <div className={`box mt-1 ${OnboardingStep2ClassName}`}>
          <ScriptSearch filmId={filmId} text={animal?.name} typeToDispatch="SET_DRESSING_SEARCH_SCRIPT" findingInScript={findingInScript} />
        </div>}
        {/* {loadingSceneSettings && <div>loadingSceneSettings</div>}
        {loadingAnimal && <div>loadingAnimal</div>}
        {loadingScenes && <div>loadingScenes</div>} */}
        <Form
          errors={errors}
          mode="edit"
          filmId={filmId}
          animalId={animalId}
          initialValues={{ selectedSceneIds: props.selectedSceneIds }}
          loading={loadingSceneSettings || loadingAnimal || loadingScenes}
          onSubmit={onUpdateAnimalScenes}
          reduxFormValues={props.reduxFormValues}
          allScenes={allScenes}
          searchedSceneIds={props.searchedScenes?.map((s) => s.id)}
          selectSearchedScenes={props.selectSearchedScenes}
          clearSceneSearchResults={clearSceneSearchResults}
          readOnly={readOnly}
        />
        <Onboarding onboardingSteps={onboardingSteps} section="Set Dressing Scenes" />
      </div>
    );
  }

  function onSearchScenes(params) {
    params.sceneSettingId = animal.sceneSettingId;
    searchScenes(
      SEARCH_SCENES_FOR_SET_DRESSING,
      filmId,
      params
    );
  }

  function onUpdateAnimalScenes(propScenes) {
    assignScenesToAnimal(filmId, animalId, propScenes.selectedSceneIds);
  }

  return allScenes ? renderForm() : renderLoading();
}

function mapStateToAnimals(state) {
  const { animalsState, form } = state;
  return {
    animal: animalsState.animal,
    allScenes: animalsState.scenes,
    allCharacters: animalsState.characters,
    allSceneSettings: animalsState.sceneSettings,
    selectedSceneIds: animalsState.selectedSceneIds,
    loadingSceneSettings: animalsState.loadingSceneSettings,
    loadingScenes: animalsState.loadingScenes,
    readOnly: animalsState.readOnly,
    searchedScenes: animalsState.searchedScenes,
    selectSearchedScenes: animalsState.selectSearchedScenes,
    findingInScript: animalsState.findingInScript,
    searchingScenes: animalsState.searchingScenes,
    errors: animalsState.errors,
    redirect: animalsState.redirect,
    onboardingSteps: animalsState.onboardingSteps,
    reduxFormValues: form?.animalScenesForm?.values
  };
}

export default
  connect(mapStateToAnimals, {
    fetchAnimal,
    fetchAllScenes,
    fetchScenesAssignedToAnimal,
    setSceneAssignedToAnimal,
    clearRedirect,
    assignScenesToAnimal,
    searchScenes,
    findInScript,
    clearSceneSearchResults
  })(AnimalScenes);
